/**
 * Step 2: Nome Completo
 * Coleta o nome completo do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { capitalizeEachWord, validateText } from '../validators';

const Step2_Nome: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ fullName: data.fullName || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (value: string) => {
    setLocalData({ fullName: value });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validateText(localData.fullName, 3);
    
    if (!validation.valid) {
      setErrors({ fullName: validation.error || 'Campo obrigatório' });
      return;
    }

    if(localData.fullName.trim().split(' ').length < 2) {
      setErrors({ fullName: 'Por favor, insira seu nome completo' });
      return;
    }
    localData.fullName = localData.fullName.trim().replace(/\s+/g, ' ');
    localData.fullName = capitalizeEachWord(localData.fullName);
    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu nome completo?"
      description="Precisamos do seu nome completo"
    >
      <FormFieldGroup
        label="Nome Completo"
        error={errors.fullName}
        required
      >
        <input
          type="text"
          placeholder="João Silva Santos"
          value={localData.fullName}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step2_Nome;
